import { matchRoutes } from "react-router";
import { queryClient } from "../../..";
import { QUERY_KEYS } from "../../../api/constants/query_keys";
import { ROUTES_XLOGS } from "../../../constants/URLs";

/**
 * Refetch user and unposted sessions count.
 * Note: For slim sessions data refetch, use the context's refetch functions
 * (refetchMyUnpostedSessions, refetchDecUnpostedSessions, refetchAssistantsUnpostedSessions)
 * since the endpoint is now mutation-based.
 */
function refetchUserAndUnpostedSessions() {
  const thisLocation = globalThis.location;
  const inUnpostedSessionsView = matchRoutes(
    [
      {
        path: ROUTES_XLOGS.unposted_sessions.mySessions,
      },
      {
        path: ROUTES_XLOGS.unposted_sessions.decSessions,
      },
      {
        path: ROUTES_XLOGS.unposted_sessions.assistantSessions,
      },
      {
        path: ROUTES_XLOGS.unposted_sessions.index,
      },
      {
        path: ROUTES_XLOGS.unposted_sessions.notator,
      },
    ],
    thisLocation,
  );

  queryClient.refetchQueries({
    queryKey: QUERY_KEYS.v1SessionsUnpostedCountGet,
  });

  if (inUnpostedSessionsView) {
    // Note: Slim sessions refetch is now handled via mutation refetch functions from context
    // This function only refetches the user data when in unposted sessions view
    queryClient.refetchQueries({
      queryKey: QUERY_KEYS.v1UsersIdGet,
    });
  }
}

export default refetchUserAndUnpostedSessions;
